/*
 *    BIG OL' NOTE HERE: We should be able to trust the URLs returned from our content
 *    systems. We should consider doing a broad verification of URLs returned from various
 *    sources to make sure they're correct, and when we're confident they are, remove this
 *    file entirely.
 */

/* Disabling this rule while we are using the names from the non-camelcase ContentAPI */
/* eslint-disable camelcase */

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

/*
 *   Card data returned from Agatha contain a leading slash in the URL, while cards from the Monolith do not.
 *   This removes the slash if it exists as a temporary measure until backend systems are updated.
 **/
function removeLeadingSlash(url) {
  if (typeof url !== "string") return url;
  return url.replace(/^\/+/g, "");
}

function getArticleHeaderUrl(content) {
  /*
   *    When we receive an article header, we should make every attempt possible to
   *    send it properly to the view page, rather than to the legacy read page.
   *    This function attempts to do so.
   */

  // If the data includes a URL that already points to the view page, just use that
  // URL.
  if (content.url?.includes("/view")) {
    return `${MONOLITH_ORIGIN}/${removeLeadingSlash(content.url)}`;
  }

  // If the data includes the header's article story ID, we can use that to get to the
  // view page as well. As of 2024-05-02, this is what's returned from the v3 content
  // API on an article header.
  if (content.story_content_id) {
    return `${MONOLITH_ORIGIN}/view/${content.story_content_id}`;
  }

  // If all else fails, rather than trying to send them to the read page, instead send
  // them to the monolith's "content" convinenience URL, which will figure out what
  // the associated article story is and then redirect *again* to the appropriate
  // view page URL.
  return `${MONOLITH_ORIGIN}/content/${content.content_id}`;
}

function getGenericViewPageUrl(content) {
  return `${MONOLITH_ORIGIN}/view/${content.content_id}`;
}

function getStandardPageUrl(content) {
  return `${MONOLITH_ORIGIN}/search/?related_to_standards=${content.content_id}`;
}

function getTextSetUrl(content) {
  return `${MONOLITH_ORIGIN}/${removeLeadingSlash(content.url)}`;
}

function getContentUrl(content) {
  const { content_type, url } = content;

  const isAbsoluteUrlRe = /^(http|https)/;
  if (isAbsoluteUrlRe.test(url)) {
    return url;
  }

  const urlGeneratorsByContentType = {
    textset: getTextSetUrl,
    articleheader: getArticleHeaderUrl,
    video: getGenericViewPageUrl,
    interactivevideolink: getGenericViewPageUrl,
    standard: getStandardPageUrl,
    articlestory: getGenericViewPageUrl,
  };
  if (content_type in urlGeneratorsByContentType) {
    const generator = urlGeneratorsByContentType[content_type];
    return generator(content);
  }

  return `${MONOLITH_ORIGIN}/${removeLeadingSlash(url)}`;
}

export default getContentUrl;
